const saveGridLayoutTrue = () => {
  return {
    type: 'SAVE_GRID_TRUE',
  }
}

const saveGridLayoutFalse = () => {
  return {
    type: 'SAVE_GRID_FALSE',
  }
}

const resetGridLayoutTrue = () => {
  return {
    type: 'RESET_GRID_TRUE',
  }
}

const resetGridLayoutFalse = () => {
  return {
    type: 'RESET_GRID_FALSE',
  }
}
const clearGridFiltersTrue = () => {
  return {
    type: 'CLEAR_GRID_FILTERS_TRUE',
  }
}

const clearGridFiltersFalse = () => {
  return {
    type: 'CLEAR_GRID_FILTERS_FALSE',
  }
}
const refreshGridTrue = () => {
  return {
    type: 'REFRESH_GRID_TRUE',
  }
}

const refreshGridFalse = () => {
  return {
    type: 'REFRESH_GRID_FALSE',
  }
}

let initialState = {
  saveGridLayout: false,
  resetGridLayout: false,
  clearGridFilters: false,
  refreshGrid: false,
}

const saveGridModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SAVE_GRID_TRUE':
      return { ...state, saveGridLayout: true }
    case 'SAVE_GRID_FALSE':
      return { ...state, saveGridLayout: false }
    case 'RESET_GRID_TRUE':
      return { ...state, resetGridLayout: true }
    case 'RESET_GRID_FALSE':
      return { ...state, resetGridLayout: false }
    case 'CLEAR_GRID_FILTERS_TRUE':
      return { ...state, clearGridFilters: true }
    case 'CLEAR_GRID_FILTERS_FALSE':
      return { ...state, clearGridFilters: false }
    case 'REFRESH_GRID_TRUE':
      return { ...state, refreshGrid: true }
    case 'REFRESH_GRID_FALSE':
      return { ...state, refreshGrid: false }
    default:
      return state
  }
}

export default saveGridModalReducer
export { saveGridLayoutTrue, saveGridLayoutFalse, resetGridLayoutTrue, resetGridLayoutFalse, clearGridFiltersTrue, clearGridFiltersFalse, refreshGridTrue, refreshGridFalse }
